import { render, staticRenderFns } from "./SideBars.vue?vue&type=template&id=4c50103e"
import script from "./SideBars.vue?vue&type=script&lang=js"
export * from "./SideBars.vue?vue&type=script&lang=js"
import style0 from "./SideBars.vue?vue&type=style&index=0&id=4c50103e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports